import { MenuItem, Select } from '@material-ui/core'

import { CommissionField } from './types'

const fieldOptions: Record<Exclude<CommissionField, 'periodType'>, { trueLabel: string; falseLabel: string }> = {
  directCommission: {
    trueLabel: 'Comissionista puro',
    falseLabel: 'Salário + Comissão'
  },
  splitCommission: {
    trueLabel: 'Vendas por período',
    falseLabel: 'Vendas do mês'
  },
  distribute: {
    trueLabel: 'Redistribuir a meta',
    falseLabel: 'Não redistribuir'
  },
  storeSold: {
    trueLabel: 'Meta da loja',
    falseLabel: 'Meta individual'
  }
}

export const FieldBooleanSelect = ({
  field,
  value,
  onChange,
  className,
  disabled = false
}: {
  className?: string
  disabled?: boolean
  field: Exclude<CommissionField, 'periodType'>
  value: boolean | null
  onChange: (value: boolean) => void
}) => {
  const options = fieldOptions[field]

  return (
    <Select className={className} value={value === null ? '' : String(value)} onChange={event => onChange(event.target.value === 'true')} displayEmpty disabled={disabled}>
      <MenuItem value='' disabled>Selecionar</MenuItem>
      <MenuItem value='true'>{options.trueLabel}</MenuItem>
      <MenuItem value='false'>{options.falseLabel}</MenuItem>
    </Select>
  )
}

export const PeriodTypeSelect = ({
  className,
  value,
  onChange
}: {
  className?: string
  value: 'single' | 'multiple' | null
  onChange: (value: 'single' | 'multiple') => void
}) => (
  <Select className={className} value={value || ''} onChange={event => onChange(event.target.value as 'single' | 'multiple')} displayEmpty>
    <MenuItem value='' disabled>Selecionar</MenuItem>
    <MenuItem value='single'>Período único</MenuItem>
    <MenuItem value='multiple'>Vários períodos</MenuItem>
  </Select>
)
